import React, { Component } from 'react'

class Breadcrumbs extends Component {
  render () {
    return (
      <div>
          {this.props.links && this.props.links.map(link => <small key={link.text} className={link.active ? 'active' : 'link'}>{link.active ? link.text : <a href={link.link}>{link.text}</a>}</small>)}
      </div>
    )
  }
}
export default Breadcrumbs



// WEBPACK FOOTER //
// ./src/components/basic/displays/Breadcrumbs.js